export default __webpack_public_path__ + "static/media/employee.2ee4390f.png";